import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { element, string, oneOfType, arrayOf, node, bool, number } from 'prop-types';
import { CardImage, Container, CardBody, CardSubtitle, CardText, CardTitle } from './card.styles';
const Card = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref
  }, props), children);
});
Card.displayName = 'Card';
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node]).isRequired
} : void 0;
Card.Image = CardImage;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Text = CardText;
Card.Body = CardBody;
const SharedTypes = {
  truncate: bool,
  lines: number
};
Card.Title.propTypes = Object.assign({}, SharedTypes);
Card.Subtitle.propTypes = Object.assign({}, SharedTypes);
Card.Text.propTypes = Object.assign({}, SharedTypes);
export default Card;